import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetJson } from '../helpers/fetchReact';
import { REST_API } from '../constants';
import { STATE_STATUS } from '../constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const initialState = {
  weatherStationStatuses: [],
  weatherStationStatus: null,
  statusLoading: STATE_STATUS.IDLE,
  weatherStationStatusError: null,
  weatherStationStatusTypes: [],
  weatherStationStatusType: {},
  typeLoading: STATE_STATUS.IDLE,
  typeError: null,
  regions: [],
  region: {},
  regionLoading: STATE_STATUS.IDLE,
  regionError: null,
};

export const selectAllWeatherStationStatuses = (state) => state.weatherStationStatuses.weatherStationStatuses;
export const selectWeatherStationStatusId = (state) => state.weatherStationStatuses.weatherStationStatus?.Id;
export const selectAllWeatherStationStatuseTypes = (state) => state.weatherStationStatuses.weatherStationStatusTypes;
export const selectWeatherStationStatusTypeId = (state) => state.weatherStationStatuses.weatherStationStatusType.Id;
export const selectAllRegions = (state) => state.weatherStationStatuses.regions;
export const selectRegionId = (state) => state.weatherStationStatuses.region.Id;

export const getStatusLoading = (state) => state.weatherStationStatuses.statusLoading;
export const getTypeLoading = (state) => state.weatherStationStatuses.typeLoading;
export const getRegionLoading = (state) => state.weatherStationStatuses.regionLoading;

export const fetchWeatherStationStatuses = createAsyncThunk(
  'weatherStationStatuses/fetchWeatherStationStatuses',
  async () => {
    const url = REST_API.WEATHER_STATIONS + 'weatherStationStatuses';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { weatherStationStatuses: state } = getState();
      return state.statusLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchWeatherStationStatusTypes = createAsyncThunk(
  'weatherStationStatuses/fetchWeatherStationStatusTypes',
  async () => {
    const url = REST_API.WEATHER_STATIONS + 'weatherStationtypes';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { weatherStationStatuses: state } = getState();
      return state.typeLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchRegions = createAsyncThunk(
  'weatherStationStatuses/fetchRegions',
  async () => {
    const url = REST_API.WEATHER_STATIONS + 'regions';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { weatherStationStatuses: state } = getState();
      return state.regionLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const weatherStationStatusesSlice = createSlice({
  name: 'weatherStationStatuses',
  initialState,
  reducers: {
    setWeatherStationStatus(state, action) {
      state.weatherStationStatus = action.payload;
    },
    setWeatherStationStatusType(state, action) {
      state.weatherStationStatusType = action.payload;
    },
    setRegion(state, action) {
      state.region = action.payload;
    },
  },
  extraReducers: {
    [fetchWeatherStationStatuses.pending]: (state) => {
      state.statusLoading = STATE_STATUS.LOADING;
    },
    [fetchWeatherStationStatuses.fulfilled]: (state, action) => {
      state.statusLoading = STATE_STATUS.SUCCESS;

      state.weatherStationStatuses = action.payload;
      if (isValueEmpty(state.weatherStationStatus) || state.weatherStationStatus.Id < 1) {
        let defaultWss = state.weatherStationStatuses.find((wss) => (wss.Name + '').toLowerCase() == 'active');
        state.weatherStationStatus = { ...defaultWss };
      }
    },
    [fetchWeatherStationStatuses.rejected]: (state, action) => {
      state.statusLoading = STATE_STATUS.FAILED;
      state.weatherStationStatusError = action.error.message;
    },

    [fetchWeatherStationStatusTypes.pending]: (state) => {
      state.typeLoading = STATE_STATUS.LOADING;
    },
    [fetchWeatherStationStatusTypes.fulfilled]: (state, action) => {
      state.typeLoading = STATE_STATUS.SUCCESS;

      let _types = action.payload;
      let nullableTypes = [];
      nullableTypes.push({ Description: '', DropdownText: '		', Id: 0, Name: ' ' }); // NOTE: Is there a reason why we're using '\t\t' for the DropdownText?
      _types.map((t) => {
        nullableTypes.push(t);
      });
      state.weatherStationStatusTypes = nullableTypes;
    },
    [fetchWeatherStationStatusTypes.rejected]: (state, action) => {
      state.typeLoading = STATE_STATUS.FAILED;
      state.typeError = action.error.message;
    },

    [fetchRegions.pending]: (state) => {
      state.regionLoading = STATE_STATUS.LOADING;
    },
    [fetchRegions.fulfilled]: (state, action) => {
      state.regionLoading = STATE_STATUS.SUCCESS;

      let _regions = action.payload;

      let nullableRegions = [];
      nullableRegions.push({ DropdownText: '', Id: 0, IsActive: true, Name: '', Number: 0 });
      _regions.map((t) => {
        nullableRegions.push(t);
      });
      state.regions = nullableRegions;
    },
    [fetchRegions.rejected]: (state, action) => {
      state.regionLoading = STATE_STATUS.FAILED;
      state.regionError = action.error.message;
    },
  },
});

export const { setWeatherStationStatus, setWeatherStationStatusType, setRegion } = weatherStationStatusesSlice.actions;
